export const getAppendStyleItem = (isActive) => ({
  width: '50%',
  height: '28px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: isActive ? '#2C73E8' : '#FFFFFF',
  color: isActive ? '#FFFFFF' : '#191D25',
  cursor: 'pointer',
  borderBottom: 'unset',
})

export const getAppendStyleItemWithCustom =
  (style = {}) =>
  (isActive, isFirstItem, isLastItem, itemsLength) => ({
    width: itemsLength === 1 ? '100%' : '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: isActive ? '#2C73E8' : '#F3F3F3',
    color: isActive ? '#FFFFFF' : '#191D25',
    cursor: 'pointer',
    borderRadius: isFirstItem
      ? '2px 0px 0px 2px'
      : isLastItem
      ? '0px 2px 2px 0px'
      : 'unset',
    borderBottom: 'unset',
    padding: '2px 6px',
    ...style,
  })
